import { setAuthSessionItem, clearAuthSession } from "utils/authSession";
import axios from "axios";
import { appConstants } from "./appConstants";
import { store } from "Store/store";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";

let tokenRefreshPromise;

async function refreshExpiredToken(expiredToken) {
  const currentToken = sessionStorage.getItem("TOKEN");
  if (currentToken && currentToken !== expiredToken) return currentToken;
  if (tokenRefreshPromise) return tokenRefreshPromise;

  tokenRefreshPromise = (async () => {
    const idleTime = store.getState()?.idle?.idleTime;
    const lastActivity = new Date(idleTime).getTime();
    if (
      Number.isFinite(lastActivity) &&
      Date.now() - lastActivity >= 120 * 60 * 1000
    ) {
      clearAuthSession();
      window.location.href = "/";
      throw new Error("Your session expired. Please sign in again.");
    }

    let loginDetails;
    try {
      loginDetails = JSON.parse(
        sessionStorage.getItem("LOGIN_DETAILS") || "null"
      );
    } catch {
      loginDetails = null;
    }
    if (!loginDetails?._id)
      throw new Error("Your session expired. Please sign in again.");

    const { data } = await axios.post(
      `${appConstants.baseURL}login/generateTokenID`,
      { id: loginDetails._id }
    );
    const token = data?.Result_Status ? data.Result_Output?.token : null;
    if (!token)
      throw new Error(
        data?.Result_Message ||
          "Unable to refresh your session. Please sign in again."
      );

    if (sessionStorage.getItem("TOKEN") !== currentToken)
      throw new Error("Your session changed. Please try again.");
    setAuthSessionItem("TOKEN", token);
    store.dispatch(IdleAction(new Date()));
    return token;
  })().finally(() => {
    tokenRefreshPromise = null;
  });

  return tokenRefreshPromise;
}

async function retryAgreementRequest(path, body, method, token) {
  const { data } = await axios({
    method,
    url: `${appConstants.baseURL}rcti-agreements${path}`,
    data: body,
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!data.Result_Status) throw new Error(data.Result_Message);
  return data.Result_Output;
}

export async function agreementRequest(
  path = "",
  body,
  method = "post",
  publicRequest = false
) {
  const requestToken = publicRequest ? null : sessionStorage.getItem("TOKEN");
  try {
    const { data } = await axios({
      method,
      url: `${appConstants.baseURL}rcti-agreements${path}`,
      data: body,
      timeout: 60000,
      headers: publicRequest
        ? {}
        : { Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}` },
    });
    if (!data.Result_Status) throw new Error(data.Result_Message);
    return data.Result_Output;
  } catch (error) {
    if (
      !publicRequest &&
      error.response?.data?.Result_Message === "TokenExpiredError"
    ) {
      try {
        const refreshedToken = await refreshExpiredToken(requestToken);
        return await retryAgreementRequest(
          path,
          body,
          method,
          refreshedToken
        );
      } catch (refreshError) {
        throw new Error(
          refreshError.response?.data?.Result_Message ||
            refreshError.message ||
            "Agreement request failed."
        );
      }
    }
    throw new Error(
      error.response?.data?.Result_Message ||
        error.message ||
        "Agreement request failed."
    );
  }
}
